import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');
window.Pusher.logToConsole = process.env.MIX_PUSHER_CLIENT_DEBUG === 'true';

let websocketJwt = document.head.querySelector('meta[name="websocket-jwt"]').getAttribute('content');

let BolognaEcho = new Echo({
    key: process.env.MIX_PUSHER_APP_KEY,
    broadcaster: 'pusher',
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: 443,
    enabledTransports: ['ws', 'wss'],
    encrypted: true,
    namespace: 'App.Bologna.Events',
    enableStats: false,
    authEndpoint: process.env.MIX_PUSHER_AUTH_ENDPOINT,
    auth: {
        headers: {
            Authorization: `Bearer ${websocketJwt}`
        },
    },
});

BolognaEcho.connector.pusher.connection.bind('unavailable', (payload) => {
    console.log(`${Date.now()} Websocket connection has become unavailable`);
});

BolognaEcho.connector.pusher.connection.bind('connected', (payload) => {
    console.log(`${Date.now()} Websocket connection has been established`);
});

BolognaEcho.connector.pusher.connection.bind('failed', (payload) => {
    console.log(`${Date.now()} Websocket connection has terminally failed`);
});

export default BolognaEcho;
